import {Button} from "antd"
import React from "react"

export default ({ submitLabel, submitIcon, disabled, loading, ghost = true, block = false }) => (
    <Button type='primary' block={block} icon={submitIcon} ghost={ghost} disabled={disabled} loading={loading} htmlType='submit'>
      {submitLabel}
    </Button>
)